module.exports = __webpack_public_path__ + "static/media/volvo.b2514847.svg";